import { useRequest } from 'ahooks'
import { Form, Modal, ModalProps } from 'antd'
import moment from 'moment'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Portfolio } from '@/schemas'

import { PortfolioForm, PortfolioValues } from './portfolio-form.component'

interface PortfolioEditProps extends ModalProps {
  portfolio: Portfolio
  onCancel: () => void
}

export const PortfolioEdit: React.FC<PortfolioEditProps> = ({ portfolio, ...props }) => {
  const { t } = useTranslation()
  const [form] = Form.useForm<PortfolioValues>()

  React.useEffect(() => {
    form.setFieldsValue({
      name: portfolio.name,
      email: portfolio.email,
      departmentId: portfolio.departmentId,
      background: portfolio.background,
      standard: portfolio.standard,
      goal: portfolio.goal,
      challenge: portfolio.challenge,
      classification: portfolio.classification,
      priority: portfolio.priority,
      date: portfolio.startDate && portfolio.endDate ? [moment(portfolio.startDate), moment(portfolio.endDate)] : null,
    })
  }, [portfolio])

  const { run, loading } = useRequest(
    (data) => ({
      url: '/api/portfolio/updatePortfolio',
      method: 'patch',
      data: {
        ...data,
        selfId: portfolio.selfId,
        type: 1,
      },
    }),
    {
      manual: true,
      onSuccess: () => {
        props.onCancel()
      },
    }
  )

  return (
    <Modal
      maskClosable={false}
      title={`${t('edit')}${t('portfolio.portfolio')}：${portfolio.name}`}
      okText={t('save')}
      okButtonProps={{ loading }}
      onOk={() => form.submit()}
      {...props}
    >
      <PortfolioForm readPermissions={portfolio.readPermissions} selfId={portfolio.selfId} form={form} onSubmit={run} />
    </Modal>
  )
}
